<script lang="ts" setup>
import { RoleEnum } from "~/types/User";
import Categories from "~/components/pages/catalog/CategoriesCarousel.vue";
import Header from '~/components/layouts/Header.vue'
import Footer from '~/components/layouts/Footer.vue'
import BottomBar from '~/components/custom-ui/BottomBar.vue'

const route = useRoute()
const { parentSpecifications } = useGlobalStore()

const specificationCarouselItems = computed(() => {    
    return parentSpecifications.filter(item => !item.parent_id)
})

</script>

<template>
    <div class="min-h-screen">
        <Header /> 

        <div class="container md:min-h-[950px]">
            <div class="my-4 lg:my-10">
                <Categories v-if="route?.query?.mode !== 'geo'" :items="specificationCarouselItems" :role="RoleEnum.CUSTOMER" has_arrows />
            </div>
            <NuxtPage />
        </div>

        <Footer />
        <BottomBar />
    </div>
</template>